export const Auth_EN = {
  // Sign up
  auth: {
    authcard: {
      unregistered: "Not a member yet?",
      create: "Create an account",
      registered: "Already a member?",
      login: "Log in",
      verify_email: "We have sent instructions for email verification to",
      forgot_password:
        "Enter the email you used to create your account with and we will send you a code for resetting your password.",
      or: "or",
    },
    login: {
      headline: "Log in to your account",
      forgot_password: "Forgot password?",
    },
    livestream: {
      headline: "Sign up or log in to participate",
    },
    create: {
      headline: "Create a new account",
      password: {
        headline: "Password must consist of at least",
        characters: "min. 8 characters",
        uppercase: "one uppercase character",
        lowercase: "one lowercase character",
        special: "one special character",
        number: "at least one number",
        match: "Passwords match",
      },
      profile: {
        headline: "Almost done",
        input: {
          username: {
            label: "Choose a unique username",
            placeholder: "Your username",
          },
        },
      },
      error: {
        invalid: "Email is not valid",
      },
    },
    forgot: {
      headline: "Forgot password",
      error: {
        invalid: "Email is not valid",
      },
    },
    verify: {
      headline: "Verify your email",
      validity:
        "Code is valid for 10 minutes after sending, if the code does not work, you can request a new one here:",
    },
    reset: {
      headline: "Reset your password",
      code: "Code from email",
      digits: "Enter the 6 digit code sent to",
    },
    input: {
      email: {
        label: "Your email address",
        placeholder: "email@domain.com",
      },
      username: {
        label: "Email or Username",
        placeholder: "email@domain.com, user name...",
      },
      password: {
        label: "Password",
        placeholder: "Your password",
        create: {
          label: "Create password",
          placeholder: "Choose a unique password",
          error: "Password does not meet the requirements",
        },
        repeat: {
          label: "Repeat password",
          placeholder: "Repeat your password",
          error: "Passwords dont match",
        },
      },
      button: {
        login: "Log in",
        create: "Create account",
        reset: "Reset",
        send_link: "Send link",
        cancel: "Cancel",
        quick_account: "Quick account",
        request: "Request a new code",
      },
    },
    terms: {
      1: "By continuing you agree to our",
      2: "Terms of use",
      3: "and",
      4: "Privacy Policy",
      5: "and confirm that you are at least 13 years old",
    },
    toast: {
      password: {
        wrong:
          "The password is invalid or this is not a password based account.",
      },
      profile: {
        incomplete: "Profile incomplete, please finish creating your profile.",
      },
    },
    log_into: "Log in to", // Will have the set brand name after "to"
    log_in_how: "How would you like to log in?",
    sign_up_how: "How would you like to sign up?",
    create_profile: "Create Your Profile",
    // auth step 2
    small_info:
      "you can always change your username, profile image and update your preferences in profile settings",
    pick_username: "Pick a username",
    profile_image: "DA Profile image",
    personalize: {
      small: "Personalizing",
      large: "Personalizing your user profile",
    },
    // ----
    // auth step 3
    all_set: "You are all set!",
    start_info:
      "DA Start your journey by connecting your game accounts or exploring the various challenges available.",
    methods: {
      button: "Sign in with",
      discord: {
        login: {
          loading: "Authenticating with Discord",
          success: "Login with Discord successful, redirecting to home page.",
          failed: {
            token: "Failed to login with token, please try again later",
            auth: "Failed to authenticate, please try again later",
          },
        },
      },
      twitch: {
        login: {
          loading: "Authenticating with Twitch",
          success: "Login with Twitch successful, redirecting to home page.",
          failed: {
            token: "Failed to login with token, please try again later",
            auth: "Failed to authenticate, please try again later",
          },
        },
      },
      anonymous: {
        login: {
          loading: "Creating anonymous account",
          success:
            "Login with anonymous account successful, redirecting to home page.",
          failed: {
            auth: "Failed to create anonymous account, please try again later",
          },
        },
      },
    },
  },
};
